$(function () {
  addTextfieldEvents();

  // Trigger saving when pressing enter

  $('[data-submit-on-enter]').on('keypress', function (ev) {
    if (ev.key == 'Enter') {
      ev.preventDefault();

      var targetButton = $(this).attr('data-submit-on-enter');
      if (!targetButton) {
        targetButton = $(this).parents('form').find('button[type="submit"]');
      }

      $(targetButton).trigger('click');
    }
  });

  // Checkbox

  $('.input-checkbox__container').each(function (index, item) {
    $(item).on('click', function () {
      var wrapper = $(item).parents('.input__wrapper');
      var isActive = wrapper[0].hasAttribute('data-has-value');
      if (isActive) {
        wrapper.removeAttr('data-has-value');
      } else {
        wrapper.attr('data-has-value', '');
      }
    });
  });

  // Custom input
  $('[data-show-input-on-click]').on('click', function (ev) {
    var inputName = $(this).attr('data-show-input-on-click');
    $('.input__wrapper[data-form-input="' + inputName + '"]').removeClass('hidden');
    $(this).parents('.input__add-custom-container').remove();
  });
});

// Add textfield events

function addTextfieldEvents() {
  $(
    '.input__wrapper input:not([textfield-events-added]), .input__wrapper textarea:not([textfield-events-added]), .input__wrapper select:not([textfield-events-added])'
  ).on('change input', function () {
    $(this).removeClass('error');
    var wrapper = $(this).parents('.input__wrapper').first();
    wrapper.removeAttr('data-error');
    wrapper.attr('textfield-events-added', '');

    if (wrapper[0].hasAttribute('data-required')) {
      if ($(this).val()) {
        wrapper.attr('data-has-value', '');
      } else {
        wrapper.removeAttr('data-has-value');
      }
    }
  });
}

// Autoresize textareas

function addAutoResize() {
  document.querySelectorAll('[data-autoresize]').forEach(function (element) {
    element.style.boxSizing = 'border-box';
    var offset = element.offsetHeight - element.clientHeight;
    $(element).on('input', function (event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + offset + 'px';
    });
    $(element).removeAttr('data-autoresize');
    $(element).attr('data-autoresize-added', '');
  });
  initAutoResize();
}

function initAutoResize() {
  document
    .querySelectorAll('[data-autoresize-added]')
    .forEach(function (element) {
      if ($(element).val()) {
        var offset = element.offsetHeight - element.clientHeight;
        element.style.height = 'auto';
        element.style.height = element.scrollHeight + offset + 'px';
      }
    });
}

// Set button percent status

function setButtonLoadingStatus(button, text, percent) {
  button = $(button);
  button.removeClass('loading-bar');
  button.addClass('button--loading-status');
  button.html(text);
  percent = 100 - parseInt(percent);
  button.css({
    backgroundImage:
      'linear-gradient(to left, #ccc 0%, #ccc ' +
      percent +
      '%, #ccc ' +
      percent +
      '%, #000 ' +
      percent +
      '%, #000 100%)'
  });
}

function resetButtonLoadingStatus(button, text, hasReadableText) {
  button = $(button);
  button.html(text);
  button[hasReadableText ? 'addClass' : 'removeClass']('-has-readable-text');
  button.removeAttr('style');
  button.removeClass('button--loading-status');
}

// Copy permalink

function copyPermalink() {
  var url = $('input[data-permalink-url]').val();
  var query = $('input[data-permalink-query]').val();
  var link = url + query;
  navigator.clipboard.writeText(link);
  var buttonEl = $('.input-permalink__copy-button');
  buttonEl.html('Kopiert');
}
